import { useContext } from "react"
import Select from "../../../components/Select/Select"
import { StaticDataContext } from "../../../views/signup-flow/SignupFormPage/SignupFormPage"
import { Option } from "../../../services/ntuc/userService/staticData"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"

function MaritalStatusSelectField(props: FormFieldProps<Option>) {
    const staticData = useContext(StaticDataContext)
    const options = staticData ? staticData.marital_status : []

    return (
        <Select
            {...props}
            label="marital_status"
            options={options}
        />
    )
}

export default MaritalStatusSelectField
